console.log('custom.js loaded');

document.addEventListener('DOMContentLoaded', function () {
  var slideshow = document.querySelector('.f-slideshow');
  if (!slideshow) return;

  var pointerDownTime;
  var pointerDownX;

  slideshow.addEventListener('pointerdown', function (e) {
    pointerDownTime = Date.now();
    pointerDownX = e.clientX;
  });

  slideshow.addEventListener('pointerup', function (e) {
    var elapsed = Date.now() - pointerDownTime;
    var distX = Math.abs(e.clientX - pointerDownX);
    if (elapsed > 300 || distX > 10) return;

    // Find the selected slide inside the flickity-slider
    var selected = slideshow.querySelector('.f-slideshow__slide.is-selected');
    if (!selected) return;
    var url = selected.dataset.videoLink;
    if (url) window.location.href = url;
  });
});